import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Slider } from "@/components/ui/slider";
import { Search } from "lucide-react";

interface BeatFiltersProps {
  genres: string[];
  onGenresChange: (genres: string[]) => void;
  onBpmChange: (bpmRange: [number, number]) => void;
  onSearchChange: (search: string) => void;
  selectedGenres: string[];
  bpmRange: [number, number];
  searchQuery: string;
}

export const BeatFilters = ({
  genres,
  onGenresChange,
  onBpmChange,
  onSearchChange,
  selectedGenres,
  bpmRange,
  searchQuery,
}: BeatFiltersProps) => {
  return (
    <Card className="mb-8">
      <CardContent className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Search Filter */}
          <div className="space-y-2">
            <Label htmlFor="search-input" className="text-sm font-medium">
              Search by Name
            </Label>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input
                id="search-input"
                type="text"
                placeholder="Search beats..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="pl-10"
              />
            </div>
          </div>

          {/* Genre Filter */}
          <div className="space-y-2">
            <Label htmlFor="genre-select" className="text-sm font-medium">
              Genre
            </Label>
            <Select
              value={selectedGenres.length === 1 ? selectedGenres[0] : "all"}
              onValueChange={(value) => onGenresChange(value === "all" ? [] : [value])}
            >
              <SelectTrigger id="genre-select">
                <SelectValue placeholder="All genres" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All genres</SelectItem>
                {genres.map((genre) => (
                  <SelectItem key={genre} value={genre}>
                    {genre}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {/* BPM Filter */}
          <div className="space-y-4">
            <Label className="text-sm font-medium">
              BPM Range: {bpmRange[0]} - {bpmRange[1]}
            </Label>
            <Slider
              value={bpmRange}
              onValueChange={(value) => onBpmChange(value as [number, number])}
              max={200}
              min={60}
              step={1}
              className="w-full slider-gradient"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};